'use strict';
import Promise from 'bluebird';
import $ from 'jquery';

const BASE_URL = '/fi/api/v1/checkout/';
const VALIDATION_API = '/fi/api/v1/validate/';

export default (data) => {
	const xhr = $.getJSON(BASE_URL + 'validate/', data);
	return Promise.resolve(xhr);
}

export const validateForm = (form, data) => {
	if (!data.fields) {
		return Promise.reject(new Error('No form fields specified for validation'));
	}
	return Promise.resolve($.getJSON(VALIDATION_API + form, data));
}
